export const isPaidPlan = (plan?: string) => plan === 'pro' || plan === 'max';
// 'expired' too: a failed weekly payment expires the plan while Stripe keeps retrying the card.
export const canManageSubscription = (plan?: string) => isPaidPlan(plan) || plan === 'expired';
